import PopupActions from "../actions/popupActions"
const initialState = {
  popupDisplay: false,
}

const popupReducer = (state = initialState, action) => {
  switch (action.type) {
    case PopupActions.ENABLE_POPUP:
      return { ...state, popupDisplay: true }
    case PopupActions.DISABLE_POPUP:
      return { ...state, popupDisplay: false }
    default:
      return state
  }
}

export default popupReducer
